import { useAsync } from "@mylaunch/components/hooks"
import { Result } from "@praha/byethrow"
import { useSetAtom } from "jotai"
import { toast } from "sonner"
import { Button } from "~/components/ui/button"
import { loginDialogAtom } from "../atoms/login"
import { sendOTP } from "../server/auth.functions"

interface Props extends Omit<React.ComponentProps<typeof Button>, "onClick"> {
  phone: string
}

export function SendOtpButton({
  phone,
  children,
  ...props
}: Props) {
  const setState = useSetAtom(loginDialogAtom)
  const { run } = useAsync((p: string) =>
    sendOTP({
      data: {
        phone: p,
      },
    }))

  const handleClick = async () => {
    setState({
      step: 2,
      phone,
    })
    const result = await run(phone)
    if (Result.isSuccess(result) && result.value === true) return
    toast.error("Не удалось отправить код")
    setState({
      step: 1,
      phone,
    })
  }

  return (
    <Button {...props} onClick={handleClick}>
      {children}
    </Button>
  )
}
